/**
 * Download de um blob já recebido do backend (`responseType: 'blob'`).
 * É o mesmo final de `downloadArquivo` (crud-helper), sem a etapa de base64 —
 * a rota de exportação dos indicadores devolve os bytes direto.
 */
export const baixarBlob = (blob: Blob, nomeArquivo: string) => {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', nomeArquivo)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
